import { FormControl } from "@angular/forms";
import { MovilityType, TripType } from "./register-user.response";

export interface RegisterUserForm {
  startDate: FormControl<Date>;
  endDate: FormControl<Date | null>;
  startTime: FormControl<string | null>;
  endTime: FormControl<string | null>;
  startLocationAddress: FormControl<string | null>;
  startLocationLat: FormControl<number | null>;
  startLocationLng: FormControl<number | null>;
  endLocation: FormControl<boolean>;
  movilityType: FormControl<MovilityType>;
  tripType: FormControl<TripType>;
  interestIdList: FormControl<number[]>;
  transportMeans: FormControl<string[]>;
  maxDistanceWalking: FormControl<number>;
  geolocation: FormControl<boolean>;
  subdomain: FormControl<string>;
}

export const statusFormMap = {
  VALID: 'VALID',
  INVALID: 'INVALID'
} as const;

export type RegisterUserFormStatus = typeof statusFormMap[keyof typeof statusFormMap];